import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	IssueDate: {
		k: "certificate.issueDate",
		v: "Issued: "
	},

	CertificateEmpty: {
		k: "certificates.empty.title",
		v: "No Earned Certificates Found"
	},

	DescriptionEmpty: {
		k: "certificates.empty.description",
		v: "Try different search parameters"
	},

	Download: {
		k: "certificate.download",
		v: "Download"
	}

});



// WEBPACK FOOTER //
// ./src/panels/certificates/Certificates.labels.ts